import { Component } from '@angular/core';

@Component({
  selector: 'empty-component',
  template: '',
})
export class EmptyComponent {
}
